import {forwardRef, type ReactNode} from "react";
import {useChecklistData} from "../ChecklistDataContext";
import {CategoryOpenIcon} from "../CategoryOpenIcon";
import {CheckStatusButtons} from "../CheckStatusButtons";
import {CommentButton} from "../CommentButton";
import type {Status} from "../../types";
import InfoCircleIcon from "../../../../assets/v2-info-circle.svg?react";
import styles from "../checklist.module.css";

export const CheckItemParent = forwardRef<
    HTMLDivElement,
    {
        children: ReactNode;
        isOpen: boolean;
        itemId: string;
        onTitleClick: () => void;
        names: Record<Status, string>;
    }
>(({children, isOpen, itemId, onTitleClick, names}, ref) => {
    const {
        viewFilteredToc,
        collectionData,
        onCheckItemStatusClick,
        infoIdSet,
    } = useChecklistData();

    const node = viewFilteredToc[itemId];
    if (!node) return null;

    const isInfoNode = infoIdSet.has(itemId) || node.info === true;

    return (
        <div className={styles.checkItemParent} data-id={itemId} data-item-id={itemId} ref={ref}>
            <header
                className={isOpen ? styles.isOpen : undefined}
                onClick={onTitleClick}
            >
                <CategoryOpenIcon isOpen={isOpen} />
                <div className={styles.checkItemTitle}>
                    <h4 data-searchable="true">{node.title}</h4>
                    {collectionData && (
                        <CommentButton variant="icon" nodeId={itemId} />
                    )}
                </div>
                {isInfoNode && (
                    <InfoCircleIcon width={20} height={20} color="var(--mantine-color-blue-5)" />
                )}
                {!isInfoNode && (
                    <CheckStatusButtons
                        itemId={itemId}
                        onStatusClick={(s) =>
                            onCheckItemStatusClick({id: itemId, status: s})
                        }
                        names={names}
                        isGroup
                    />
                )}
            </header>
            {children}
        </div>
    );
});

CheckItemParent.displayName = "CheckItemParent";
